import { action } from 'mobx';
import Sketch from '@arcgis/core/widgets/Sketch';
import { LandLevelingDesignStore } from 'cd-eft/models/Stores/LandLevelingDesignStore';
import { PadDesignStore } from 'cd-eft/models/Stores/PadDesignStore';
import { PitDesignStore } from 'cd-eft/models/Stores/PitDesignStore';
import stores from 'cd-eft/models/Stores';
import { MapView } from 'cd-eft/utils/esriTypes';

const { designStore } = stores.AppStore;

export interface IDesignTabContainerProps {
  mapView?: MapView;
  store: PitDesignStore | PadDesignStore | LandLevelingDesignStore;
  title: string;
  summaryComponent: any;
  editFormComponent: any;
  sketchInitCallback?: any;
  sketchWidget?: Sketch;
}

export class DesignTabContainerVM {
  public mapView?: MapView;
  public store: PitDesignStore | PadDesignStore | LandLevelingDesignStore;
  public title: string;
  public tabTitles: ITabOptions;

  constructor(props: IDesignTabContainerProps) {
    if (props.mapView) {
      this.mapView = props.mapView;
      if (props.sketchInitCallback) {
        props.sketchInitCallback(props.mapView, props.sketchWidget);
      }
    }
    this.store = props.store;
    this.tabTitles = {
      summary: this.store.surveyListDataGridTabs[0],
      editForm: this.store.surveyListDataGridTabs[1],
    };
    this.title = props.title;
  }
  @action.bound handleClick() {
    designStore.showSettingsPopup = !designStore.showSettingsPopup;
    if (this.title === 'Land Leveling Design') {
      designStore.currentDesignSettingsTab = 'Land Leveling';
    } else {
      designStore.currentDesignSettingsTab = 'General';
    }
  }
}

interface ITabOptions {
  summary: string;
  editForm: string;
}
